"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowHeaderCell = exports.TableColumnHeaderCell = exports.TableCell = exports.TableRow = exports.TableBody = exports.TableHeader = exports.TableRoot = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const table_props_js_1 = require("./table.props.js");
const index_js_1 = require("../helpers/index.js");
const scroll_area_js_1 = require("./scroll-area.js");
const TableRoot = React.forwardRef((props, forwardedRef) => {
    const { layout: layoutPropDef, ...rootPropDefs } = table_props_js_1.tableRootPropDefs;
    const { className, children, layout, ...rootProps } = (0, index_js_1.extractProps)(props, rootPropDefs, index_js_1.marginPropDefs);
    const tableLayoutClassNames = (0, index_js_1.getResponsiveClassNames)({
        value: layout,
        className: table_props_js_1.tableRootPropDefs.layout.className,
        propValues: table_props_js_1.tableRootPropDefs.layout.values,
    });
    return (React.createElement("div", { ref: forwardedRef, className: (0, classnames_1.default)('rt-TableRoot', className), ...rootProps },
        React.createElement(scroll_area_js_1.ScrollArea, null,
            React.createElement("table", { className: (0, classnames_1.default)('rt-TableRootTable', tableLayoutClassNames) }, children))));
});
exports.TableRoot = TableRoot;
TableRoot.displayName = 'Table';
const TableHeader = React.forwardRef(({ className, ...props }, forwardedRef) => (React.createElement("thead", { ...props, ref: forwardedRef, className: (0, classnames_1.default)('rt-TableHeader', className) })));
exports.TableHeader = TableHeader;
TableHeader.displayName = 'TableHeader';
const TableBody = React.forwardRef(({ className, ...props }, forwardedRef) => (React.createElement("tbody", { ...props, ref: forwardedRef, className: (0, classnames_1.default)('rt-TableBody', className) })));
exports.TableBody = TableBody;
TableBody.displayName = 'TableBody';
const TableRow = React.forwardRef((props, forwardedRef) => {
    const { className, ...rowProps } = (0, index_js_1.extractProps)(props, table_props_js_1.tableRowPropDefs);
    return React.createElement("tr", { ...rowProps, ref: forwardedRef, className: (0, classnames_1.default)('rt-TableRow', className) });
});
exports.TableRow = TableRow;
TableRow.displayName = 'TableRow';
const TableCellImpl = React.forwardRef((props, forwardedRef) => {
    const { tag: Tag = 'td', className, ...cellProps } = (0, index_js_1.extractProps)(props, table_props_js_1.tableCellPropDefs);
    return (React.createElement(Tag, { ...cellProps, ref: forwardedRef, className: (0, classnames_1.default)('rt-TableCell', className) }));
});
TableCellImpl.displayName = 'TableCellImpl';
const TableCell = React.forwardRef((props, forwardedRef) => (React.createElement(TableCellImpl, { ...props, tag: "td", ref: forwardedRef })));
exports.TableCell = TableCell;
TableCell.displayName = 'TableCell';
const TableColumnHeaderCell = React.forwardRef(({ className, ...props }, forwardedRef) => (React.createElement(TableCellImpl, { scope: "col", ...props, tag: "th", ref: forwardedRef, className: (0, classnames_1.default)('rt-TableColumnHeaderCell', className) })));
exports.TableColumnHeaderCell = TableColumnHeaderCell;
TableColumnHeaderCell.displayName = 'TableColumnHeaderCell';
const TableRowHeaderCell = React.forwardRef(({ className, ...props }, forwardedRef) => (React.createElement(TableCellImpl, { scope: "row", ...props, tag: "th", ref: forwardedRef, className: (0, classnames_1.default)('rt-TableRowHeaderCell', className) })));
exports.TableRowHeaderCell = TableRowHeaderCell;
TableRowHeaderCell.displayName = 'TableRowHeaderCell';
//# sourceMappingURL=table.js.map